<nb-card>
  <nb-card-body>
    <ckeditor
      [editor]="Editor"
      [config]="config"
      [disabled]="readOnly"
      [(ngModel)]="value"
      (ready)="onReady($event)"
    ></ckeditor>
  </nb-card-body>
</nb-card>
